import { USER_PERMISSIONS, USER_PERMISSION_KEYS } from '../../util/constants'
import { NullablePartial } from '../tools'

export type UserPermission = (typeof USER_PERMISSIONS)[number]

// NOTE: read-only fields won't be writable
export type User = {
    id: string
    name: string
    permissions: UserPermission[]
    companyId: string
    isAdmin: boolean
    username?: string
    email: string
    phone?: string
    token: string
    meta?: {
        [key: string]: any
    } | null
}

export type UserMeta = {
    reports?: {
        yardreport: Array<string>
        gatefeed: Array<string>
    }
}

export type DraftUser = NullablePartial<User & { password: string }>

export type UserDirectory = Record<string, User>

export const isUserPermission = (value: string): value is UserPermission => {
    const permissionSet = new Set(USER_PERMISSION_KEYS)
    return permissionSet.has(value)
}

export const isUserPermissionSet = (values: string[]): values is UserPermission[] => {
    // eslint-disable-next-line no-restricted-syntax
    for (const permissionKey of values || []) {
        if (!isUserPermission(permissionKey)) return false
    }
    return true
}
